import React from 'react';
import {
  Dialog,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  CloseOutlined as CloseOutlinedIcon,
  makeStyles,
} from '@quillbot/design-system';
import { NativePlatform } from 'core/models/platform';
import StyledPremiumButton from '@Common/quillElements/button/PremiumButton';

export interface ModalProps {
  isCloseBtn?: boolean;
  title?: string;
  modalContent: JSX.Element | string;
  ctaText?: string;
  onCtaClick?: Function | any;
  isPremiumCta?: boolean;
  onClose: Function;
  native?: NativePlatform | any;
  open: boolean;
  isIE?: boolean;
  ctaReferrer?: string;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.down(400)]: {
      margin: '12px',
    },
    overflow: 'inherit',
  },
  paperWidthFalse: {
    maxWidth: '936px',
    [theme.breakpoints.down(400)]: {
      maxWidth: '100%',
    },
  },
  modeBox: {
    maxWidth: '150px',
    margin: 'auto',
  },
  paperFullWidth: {
    [theme.breakpoints.down(400)]: {
      maxWidth: 'calc(100% - 24px)',
      width: 'calc(100% - 24px)',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '26px',
    fontWeight: 600,
    // paddingBottom: '44px',
    [theme.breakpoints.down(767)]: {
      maxWidth: '215px',
      margin: 'auto',
      //   paddingBottom: '30px',
    },
  },
  titleForIE: {
    [theme.breakpoints.down(767)]: {
      margin: '0',
    },
  },
  button: {
    borderRadius: '100px',
    width: '26%',
    fontSize: '16px',
    fontWeight: 600,
    height: '40px',
    [theme.breakpoints.down(768)]: {
      width: '250px',
      padding: '0 20px',
    },
  },
}));

export function QuillModal(props: ModalProps) {
  const {
    title,
    onClose,
    isCloseBtn,
    isPremiumCta,
    ctaText,
    onCtaClick,
    native,
    open,
    modalContent,
    isIE,
    ctaReferrer,
    ...otherProps
  } = props;
  const classes = useStyles();
  let btnBlock: JSX.Element | string;
  if (isPremiumCta) {
    btnBlock = (
      <StyledPremiumButton
        color="secondary"
        style={{
          paddingLeft: '16.5px',
          paddingRight: '16.5px',
          fontWeight: 600,
          borderRadius: '50px',
          fontSize: '20px',
        }}
        referrer={ctaReferrer}
        text={ctaText}
        onClick={onCtaClick}
        native={native}
        close={onClose}
      />
    );
  } else {
    btnBlock = (
      <Button onClick={onCtaClick} className={classes.button} variant="contained" color="primary">
        {ctaText}
      </Button>
    );
  }

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      classes={{
        paperWidthFalse: classes.paperWidthFalse,
        paper: classes.paper,
        paperFullWidth: classes.paperFullWidth,
      }}
      {...otherProps}>
      <Box display="flex" justifyContent="flex-end">
        {isCloseBtn && (
          <IconButton style={{ padding: '8px' }} onClick={() => onClose()} size="large">
            <CloseOutlinedIcon />
          </IconButton>
        )}
      </Box>
      {title && (
        <DialogTitle sx={{ textAlign: 'center', padding: 0 }}>
          {!isCloseBtn && <Box pt={{ lg: '30px', md: '20px', xs: '10px' }} />}
          <Typography
            className={`${classes.title} ${isIE ? classes.titleForIE : undefined}`}
            variant="h5"
            pb={{ lg: '20px', sm: '10px' }}>
            {title}
          </Typography>
        </DialogTitle>
      )}

      <DialogContent sx={{ overflowX: 'inherit' }}>{modalContent}</DialogContent>

      {ctaText && (
        <Box pt={{ lg: '30px', md: '20px', xs: '10px' }} pb={{ lg: '30px', md: '30px', xs: '20px' }} textAlign="center">
          {btnBlock}
        </Box>
      )}
    </Dialog>
  );
}

export default QuillModal;
